import { fetchData } from "@client";

export async function getActiveProjectsQuery(workspaceUuid) {
  const { results } = await fetchData(`/project?workspace=${workspaceUuid}`);
  return results;
}
